var map = {
	"./bg/core": [
		9630,
		630
	],
	"./cs/core": [
		6341,
		341
	],
	"./da/core": [
		2939,
		939
	],
	"./de/core": [
		2951,
		951
	],
	"./en/core": [
		4675
	],
	"./es/core": [
		8631,
		631
	],
	"./fr/core": [
		5031,
		31
	],
	"./hu/core": [
		8742,
		742
	],
	"./id/core": [
		251,
		251
	],
	"./it/core": [
		7137,
		137
	],
	"./ja/core": [
		6,
		6
	],
	"./ko/core": [
		1382,
		144
	],
	"./nl/core": [
		699,
		699
	],
	"./pl/core": [
		2394,
		394
	],
	"./pt/core": [
		5513,
		894
	],
	"./ro/core": [
		3902,
		902
	],
	"./ru/core": [
		7696,
		696
	],
	"./sk/core": [
		480,
		480
	],
	"./sv/core": [
		9370,
		989
	],
	"./tr/core": [
		4388,
		388
	],
	"./ua/core": [
		3720,
		720
	],
	"./uz/core": [
		7847,
		847
	],
	"./zh/core": [
		2532,
		532
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5165;
module.exports = webpackAsyncContext;